import React from "react";
import ReactDOM from "react-dom";
import Root from "./pages/Root";
import configureStore from "./store/configureStore";
import "./utils/global";


// Styles
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./style/style.scss";
// Temp fix for reactstrap
import "./style/core/_dropdown-menu-right.scss";

import "ladda/dist/ladda-themeless.min.css";

import "react-toastify/dist/ReactToastify.css";

// Import Fonts
import "../public/fonts/MyFontsWebfontsKit.css";

let initialState = {
  auth: {},
};

const store = configureStore(initialState);

ReactDOM.render(<Root store={store} />, document.getElementById("root"));
